module.exports = __webpack_public_path__ + "static/assets/f3d3d964d62acbfe4bd972f0f055dfb1.svg";